import React from 'react'

const Dashboard = () => {
  return (
    <div className='flex justify-center min-h-screen items-center text-white text-3xl h-full'>
      Welcome to QuickLearn!!
    </div>
  )
}

export default Dashboard
